import { CartPanel } from "../features/cart/CartPanel";
import { MarketsSection } from "../features/markets/MarketsSection";
import { PortfolioSection } from "../features/portfolio/PortfolioSection";
import { RebalanceSection } from "../features/rebalance/RebalanceSection";
import { WalletBalanceCard } from "../features/wallet/WalletBalanceCard";

/**
 * Single-screen, read-only dashboard.
 *
 *   ┌────────────────────────────┬───────────┐
 *   │ Portfolio  ·  Markets      │           │
 *   ├────────────────────────────┤   Cart    │
 *   │ Rebalance                  │           │
 *   └────────────────────────────┴───────────┘
 *
 * Wallet is server-resolved (`KAM_WALLET_ADDRESS`); the cart sidebar
 * holds user-driven intents (withdraw from a position, send-rebalance
 * from the optimizer preview) and owns Simulate / Execute.
 *
 * On narrow screens the grid collapses to one column with the cart
 * dropping under the rebalance section.
 */
export function Dashboard() {
	return (
		<div className="space-y-8">
			<DashboardHero />

			<div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
				<div className="space-y-8 lg:col-span-8 xl:col-span-9">
					<div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
						<PortfolioSection />
						<MarketsSection />
					</div>
					<RebalanceSection />
				</div>

				<div className="space-y-4 lg:col-span-4 xl:col-span-3">
					<WalletBalanceCard />
					<CartPanel />
				</div>
			</div>
		</div>
	);
}

function DashboardHero() {
	return (
		<header className="space-y-2">
			<h1 className="text-3xl font-semibold tracking-tight">
				kam<span className="text-emerald-400">·</span>yield
			</h1>
			<p className="text-sm text-slate-400">
				Portfolio, markets, and the optimizer's preview — one read-only
				dashboard. Queue trades on the right, then Simulate + Execute.
			</p>
		</header>
	);
}
